export const PRE_CLINICAL_PRODUCT_NAME = 'Preclinical & Step 1';
export const STEP_SHELF_PRODUCT_NAME = 'Ora Pro';
